'use strict';

var textShortTemplate = require('./field-templates/text-short/preview.html');
var textLongTemplate = require('./field-templates/text-long/preview.html');
var dateTemplate = require('./field-templates/date/preview.html');
var durationTemplate = require('./field-templates/duration/preview.html');
var scaleTemplate = require('./field-templates/scale/preview.html');
var listTemplate = require('./field-templates/list/preview.html');
var locationTemplate = require('./field-templates/location/preview.html');
var fileTemplate = require('./field-templates/file/preview.html');
var referenceLinkTemplate = require('./field-templates/reference-link/preview.html');

module.exports.directive = [
  'TransformerDirectiveFactory',
  FormFieldPreviewDirective];

module.exports.templates = [
  '$templateCache',
  CacheTemplates];

function CacheTemplates($templateCache) {
  $templateCache.put('forms/text-short/preview.html', textShortTemplate);
  $templateCache.put('forms/text-long/preview.html', textLongTemplate);
  $templateCache.put('forms/date/preview.html', dateTemplate);
  $templateCache.put('forms/duration/preview.html', durationTemplate);
  $templateCache.put('forms/scale/preview.html', scaleTemplate);
  $templateCache.put('forms/list/preview.html', listTemplate);
  $templateCache.put('forms/location/preview.html', locationTemplate);
  $templateCache.put('forms/file/preview.html', fileTemplate);
  $templateCache.put('forms/reference-link/preview.html', referenceLinkTemplate);
}

function FormFieldPreviewDirective(TransformerDirectiveFactory) {
  var transformConfig = {
    modes: [
      {name: 'text_short', templateUrl: 'forms/text-short/preview.html', defaultMode: true},

      {name: 'text_long', templateUrl: 'forms/text-long/preview.html'},

      {name: 'date', templateUrl: 'forms/date/preview.html'},

      {name: 'duration', templateUrl: 'forms/duration/preview.html'},

      {name: 'scale', templateUrl: 'forms/scale/preview.html'},

      {name: 'list', templateUrl: 'forms/list/preview.html'},

      {name: 'location', templateUrl: 'forms/location/preview.html'},

      {name: 'file', templateUrl: 'forms/file/preview.html'},

      {name: 'reference_link', templateUrl: 'forms/reference-link/preview.html'}
    ]
  };

  return {
    restrict: 'E',
    template: '',
    scope: {
      currentMode: '=?'
    },
    compile: TransformerDirectiveFactory(transformConfig)
  }
}


// WEBPACK FOOTER //
// ./src/js/forms/directives/FormFieldPreviewDirective.js